module.exports = __webpack_public_path__ + "images/xibao_top_semi_backview_2025.1782880901430.jpg";